<template>
  <div class="list__item flex leading-normal px-6 space-x-6">
    <div v-if="selectable" class="flex-none py-5">
      <label class="custom-checkbox">
        <input type="checkbox" @input="handleCheckbox" :checked="checked" />
        <span />
      </label>
    </div>
    <div class="flex-1 py-5">
      <slot />
    </div>
    <div v-if="actionable" class="flex-none py-5 self-start text-right -mr-3">
      <Dropdown class="w-16">
        <template #button="{ open }">
          <BaseLinkButton purple @click="open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </BaseLinkButton>
        </template>
        <template slot-scope="{ closeAction }">
          <slot name="actions" :close-action="closeAction" />
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Item',
  props: {
    selectable: Boolean,
    actionable: Boolean,
    checked: Boolean,
  },
  methods: {
    handleCheckbox(ev) {
      const { checked } = ev.target;
      this.$emit('checked', checked);
    },
  },
};
</script>
